import { render, staticRenderFns } from "./VaultMoveConfirm.vue?vue&type=template&id=33f615fc&scoped=true&"
import script from "./VaultMoveConfirm.vue?vue&type=script&lang=ts&"
export * from "./VaultMoveConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./VaultMoveConfirm.vue?vue&type=style&index=0&id=33f615fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f615fc",
  null
  
)

export default component.exports